<template>
	<div class="c-dashboard__wrap c-pending-assignments"
        :data-component-name="$options.name"
	>
		<div class="o-userProfile-select" v-if="myProfile.role=='ADMINISTRATOR' || myProfile.role=='MANAGER'">
			<UserProfileInput
				v-model="userProfile"
				label="Utilisateur"
				@input="changeInbox($event)"
				:clearable="false"
			/>
		</div>
		<div class="c-pending-assignments__wrap">
			<h5>Affectations en attente d'acceptation</h5>
			<table class="c-pending-assignments-list__wrap -mobile-block">
				<thead>
					<tr>
						<th colspan="99">
							<button class="c-notifications-filter__sort"
								@click="clickedProjects=[];clickedAssignments=[];$apollo.queries.projectsInbox.refetch()"
							>
								Rafraichir
								<q-spinner
									class="o-refresh-icn"
									v-if="$apollo.queries.projectsInbox.loading "
								/>
								<q-icon v-else class="o-refresh-icn" name="refresh"/>
							</button>
						</th>
					</tr>
					<tr>
						<th>
							Nom du projet
						</th>
						<th>
							Client
						</th>
						<th>
							Durée
						</th>
						<th>
							Dernière modification
						</th>
					</tr>
				</thead>
				<tbody v-if="$apollo.loading && !loadingMoreInbox">
					<tr>
						<td colspan="99">
							<q-spinner class="q-mr-sm" />Chargement...
						</td>
					</tr>
				</tbody>
				<tbody
					v-else
					:key="n"
					@click.stop="toggleExpandedProject(project)"
					v-for="(project, n) in projectsInbox.data"
					:id="'project' + project.id"
					class="c-project-row"
				>
					<tr class="c-project-row-main">
						<td class="c-project-row-name" data-title="Nom du projet">
							{{ project.name }} <small>(id: {{project.id}})</small>
						</td>
						<td class="c-project-row-infos" data-title="Client">
							{{ (project.customers.length>0 ? project.customers.map(e => e.name).join(", ") : '--' ) }}
						</td>
						<td class="c-project-row-infos" data-title="Durée">
							{{ $str2date(project.start_date).getDate() + ' ' + $monthStr($str2date(project.start_date)).full.toLowerCase() + ' ' + $str2date(project.start_date).getFullYear() + ' au ' + $str2date(project.end_date).getDate() + ' ' + $monthStr($str2date(project.end_date)).full.toLowerCase() + ' ' + $str2date(project.end_date).getFullYear()  }}
						</td>
						<td class="c-project-row-subinfos" data-title="Dernière modification">
							{{ project.updated_at }}
						</td>
						<!-- <td colspan="99"><pre>{{ project }}</pre></td> -->
					</tr>


					<tr class="c-project-row-expanded__wrap" @click.stop>
						<td colspan="99">
							<div class="-project-details" v-if="project.description && project.description!=''" v-html="$nl2br(project.description)">
							</div>
							<!-- <pre>{{ project.userAssignments }}</pre> -->
							<table class="c-assignments-details-table">
								<thead>
									<tr>
										<th>
											Date d'affectation
										</th>
										<th>
											Heures
										</th>
										<th>
											Quart de travail
										</th>
										<th>
											Metier
										</th>
										<th class="-actions">
										</th>
									</tr>
								</thead>

								<tbody v-if="!loading">
									<tr>
										<td class="-hidden-sm" colspan="4"></td>

										<td class="-actions" v-if="myUserProfileRole=='ADMINISTRATOR' || myUserProfileID==userProfileID">
											<AcceptationSelect
												:userProfileID="userProfileID"
												:lastDenyReason="lastDenyReason"
												:outline="false"
												size="0.75rem"
												acceptButton="Accepter tout"
												denyButton="Refuser tout"
												@accept-assignment="acceptAssignment($event, project, project.id)"
											/>
											<!-- <q-btn
											   :disable="clickedProjects.includes(project.id)"
												size="0.75rem"
												color="red"
												rounded
												no-caps
												icon-right="thumb_down"
												@click.stop="acceptAssignment( 'deny', project, project.id)"
											>
												Refuser	tout
											</q-btn>
											<q-btn
											   :disable="clickedProjects.includes(project.id)"
												size="0.75rem"
												color="green"
												rounded
												no-caps
												icon-right="thumb_up"
												@click.stop="acceptAssignment( 'accept', project, project.id)"
											>
													Accepter tout
											</q-btn> -->
										</td>
									</tr>
								</tbody>
								<tbody v-if="loading">
									<tr class="c-assignment-row">
										<td colspan="99">
											<q-spinner class="q-mr-sm" />Chargement...
										</td>
									</tr>
								</tbody>
								<tbody
									v-else
									onclick="this.classList.toggle('-expanded')"
									:key="r"
									:id="'assignment'+assignment.id"
									v-for="(assignment, r) in project.userAssignments.data"
									class="c-assignment-row__wrap"
								>
									<tr class="c-assignment-row">
										<td data-title="Date d'affectation">
											{{ parseDate(assignment.date) }}
										</td>
										<td data-title="Heures">
											{{ assignment.start_time.split(":")[0] + ':' + assignment.start_time.split(":")[1] }} à {{ assignment.end_time.split(":")[0] + ':' + assignment.end_time.split(":")[1] }}
										</td>
										<td data-title="Quart de travail">
											{{ assignment.shift.name }}
										</td>
										<td data-title="Métier">
											{{ assignment.profession.name }}
											{{ assignment.acceptedByUser }}
										</td>
										<td class="-actions" v-if="myUserProfileRole=='ADMINISTRATOR' || myUserProfileID==userProfileID">
											<AcceptationSelect
												:userProfileID="userProfileID"
												:lastDenyReason="lastDenyReason"
												:outline="true"
												size="0.75rem"
												acceptButton="Accepter"
												denyButton="Refuser"
												@accept-assignment="acceptAssignment($event, project, project.id, assignment.id)"
											/>

											<!-- <q-btn
											   :disable="clickedAssignments.includes(assignment.id) || clickedProjects.includes(project.id)"
												size="0.75rem"
												color="red"
												rounded
												outline
												no-caps
												icon-right="thumb_down"
												@click.stop="acceptAssignment( 'deny', project, project.id, assignment.id)"
											>
												Refuser
											</q-btn>
											<q-btn
											   :disable="clickedAssignments.includes(assignment.id) || clickedProjects.includes(project.id)"
												size="0.75rem"
												color="green"
												rounded
												outline
												no-caps
												icon-right="thumb_up"
												@click.stop="acceptAssignment( 'accept', project, project.id, assignment.id)"
											>
												Accepter
											</q-btn> -->
										</td>
									</tr>
									<tr class="c-assignment-row-details">
										<td colspan="99">
											<div class="-details">
												<div v-if="assignment.projectShift && assignment.projectShift.description && assignment.projectShift.description!=''" style="min-width:100%;">
													<div class="o-label">
														Description
													</div>
													<div
														v-html="$nl2br(assignment.projectShift.description)"
													></div>
												</div>
												<div v-if="assignment.projectShift && assignment.projectShift.courses.length>0">
													<div class="o-label" v-if="assignment.projectShift.courses.length==1">
														Formation
													</div>
													<div class="o-label" v-if="assignment.projectShift.courses.length>1">
														Formations
													</div>
													<div class="o-value" v-html="'<span>' + assignment.projectShift.courses.map(e => e.name).join('</span> <span>') +'</span>'">
													</div>
												</div>
												<div v-if="assignment.projectShift && assignment.projectShift.skills.length>0">
													<div class="o-label" v-if="assignment.projectShift.skills.length==1">
														Compétence
													</div>
													<div class="o-label" v-if="assignment.projectShift.skills.length>1">
														Compétences
													</div>
													<div class="o-value" v-html="'<span>' + assignment.projectShift.skills.map(e => e.name).join('</span> <span>') +'</span>'">
													</div>
												</div>
												<!-- <pre>{{assignment.customtags}}</pre> -->
												<div v-if="assignment.projectShift && (customtagsGroups=groupCustomtags(assignment.projectShift.customtags))" style="display:none"></div>
												<div :key="'act'+act" v-for="(customtagsGroup, act) in customtagsGroups">
													<div class="o-label" v-if="customtagsGroup.length==1">
														{{ customtagsGroup[0].label.name }}
													</div>
													<div class="o-label" v-if="customtagsGroup.length>1">
														{{ customtagsGroup[0].label.name }}
													</div>
													<div class="o-value" v-html="'<span>' + customtagsGroup.map(e => e.name).join('</span> <span>') +'</span>'">
													</div>
												</div>
												<div v-if="assignment.projectShift && (resourcesGroups=groupResources(assignment.projectShift.resources))" style="display:none"></div>
												<div  :key="'arg'+arg" v-for="(resourcesGroup, arg) in resourcesGroups">
													<div class="o-label" v-if="resourcesGroup.length==1">
														{{ resourcesGroup[0].type.name }}
													</div>
													<div class="o-label" v-if="resourcesGroup.length>1">
														{{ resourcesGroup[0].type.name }}
													</div>
													<div class="o-value" v-html="'<span>' + resourcesGroup.map(e => e.name).join('</span> <span>') +'</span>'">
													</div>
												</div>
												<div v-if="assignment.projectShift && (resourcesGroups=groupResources(assignment.projectShift.staffVehicules))" style="display:none"></div>
												<div  :key="'sv'+sv" v-for="(resourcesGroup, sv) in resourcesGroups">
													<div class="o-label" v-if="resourcesGroup.length==1">
														{{ resourcesGroup[0].type.name }}
													</div>
													<div class="o-label" v-if="resourcesGroup.length>1">
														{{ resourcesGroup[0].type.name }}
													</div>
													<div class="o-value" v-html="'<span>' + resourcesGroup.map(e => e.name + ' de ' + e.userProfile.name).join('</span> <span>') +'</span>'">
													</div>
												</div>
												<!-- <pre>{{ assignment }}</pre> -->
											</div>
										</td>
									</tr>
								</tbody>
								<tbody>
									<tr>
										<td colspan="99" v-if="!loading && project.userAssignments && project.userAssignments.paginatorInfo && project.userAssignments.paginatorInfo.hasMorePages">
											<div v-if="loadingMore" class="text-center">
												<q-spinner class="q-mr-sm" />Chargement...
											</div>
											<div v-else class="text-center">
												<q-btn size="0.75rem" no-caps rounded outline color="primary" @click.stop="getMoreAssignments(project)">Charger plus d'affectations...</q-btn>
											</div>
										</td>
										<td colspan="99" v-else></td>
										<!-- <td class="-actions">
											<q-btn
											   :disable="clickedProjects.includes(project.id)"
												size="0.75rem"
												color="blue"
												rounded
												outline
												no-caps
												icon-right="thumb_up"
												@click.stop="acceptAssignment( 'accept', project, project.id)"
											>
													Accepter tout
											</q-btn>
											<q-btn
											   :disable="clickedProjects.includes(project.id)"
												size="0.75rem"
												color="red"
												rounded
												outline
												no-caps
												icon-right="thumb_down"
												@click.stop="acceptAssignment( 'deny', project, project.id)"
											>
												Refuser	tout
											</q-btn>
										</td> -->
									</tr>
								</tbody>
								<tbody>
									<tr class="c-project-row-details">
										<td colspan="99">
											<div class="-details">

												<div v-if="project.customers.length>0">
													<div class="o-label" v-if="project.customers.length==1">
														Client
													</div>
													<div class="o-label" v-if="project.customers.length>1">
														Clients
													</div>
													<div class="o-value" v-html="'<span>' + project.customers.map(e => e.name).join('</span> <span>') +'</span>'">
													</div>
												</div>

												<div v-if="project.projectManager" class="">
													<div class="o-label">
														Chargé de projet
													</div>
													<div class="o-value">
														{{ project.projectManager.name }}
													</div>
												</div>

												<div v-if="project.contract_number" class="">
													<div class="o-label">
														No de contrat
													</div>
													<div class="o-value">
														{{ project.contract_number }}
													</div>
												</div>

												<div v-if="project.supervisor">
													<div class="o-label">
														Superviseur
													</div>
													<div class="o-value">
														{{ project.supervisor.name }}
													</div>
												</div>


												<div v-if="project.contacts.length>0">
													<div class="o-label" v-if="project.contacts.length==1">
														Contact
													</div>
													<div class="o-label" v-if="project.contacts.length>1">
														Contacts
													</div>
													<div class="o-value" v-html="'<span>' + project.contacts.map(e => e.name).join('</span> <span>') +'</span>'">
													</div>
												</div>

												<div v-if="project.locations.length>0">
													<div class="o-label" v-if="project.locations.length==1">
														Lieu de rassemblement
													</div>
													<div class="o-label" v-if="project.locations.length>1">
														Lieux de rassemblement
													</div>
													<div class="o-value" v-html="'<span>' + project.locations.map(e => e.name).join('</span> <span>') +'</span>'">
													</div>
												</div>

<!-- <pre>{{ project.customtagsGroups }}</pre> -->
												<div v-if="customtagsGroups=groupCustomtags(project.customtags)" style="display:none"></div>
												<div  :key="ct" v-for="(customtagsGroup, ct) in customtagsGroups">
													<div class="o-label" v-if="customtagsGroup.length==1">
														{{ customtagsGroup[0].label.name }}
													</div>
													<div class="o-label" v-if="customtagsGroup.length>1">
														{{ customtagsGroup[0].label.name }}
													</div>
													<div class="o-value" v-html="'<span>' + customtagsGroup.map(e => e.name).join('</span> <span>') +'</span>'">
													</div>
												</div>
<!-- <pre>{{ project}}</pre> -->
												<div v-if="resourcesGroups=groupResources(project.resources)" style="display:none"></div>
												<div  :key="'arg'+arg" v-for="(resourcesGroup, arg) in resourcesGroups">
													<div class="o-label" v-if="resourcesGroup.length==1">
														{{ resourcesGroup[0].type.name }}
													</div>
													<div class="o-label" v-if="resourcesGroup.length>1">
														{{ resourcesGroup[0].type.name }}
													</div>
													<div class="o-value" v-html="'<span>' + resourcesGroup.map(e => e.name).join('</span> <span>') +'</span>'">
													</div>
												</div>

												<!-- <div v-if="resourcesGroups=groupResources(project.staffVehicules)" style="display:none"></div>
												<div  :key="'sv'+sv" v-for="(resourcesGroup, sv) in resourcesGroups">
													<div class="o-label" v-if="resourcesGroup.length==1">
														{{ resourcesGroup[0].type.name }}
													</div>
													<div class="o-label" v-if="resourcesGroup.length>1">
														{{ resourcesGroup[0].type.name }}
													</div>
													<div class="o-value" v-html="'<span>' + resourcesGroup.map(e => e.name + ' de ' + e.userProfile.name).join('</span> <span>') +'</span>'">
													</div>
												</div> -->

												<div v-if="project.description" class="q-pr-none" style="min-width:100%">
													<div class="o-label">
														Description
													</div>
													<div class="o-value" v-html="$nl2br(project.description)">
													</div>
												</div>

											</div>
										</td>
									</tr>
								</tbody>

							</table>
						</td>
					</tr>


				</tbody>
				<tbody v-if="!$apollo.loading && projectsInbox.paginatorInfo.hasMorePages">
					<tr id="js-loadMoreEl" ref="loadMoreEl">
						<td colspan="99" class="loadMoreTD">
							<div v-if="loadingMoreInbox">
								<q-spinner class="q-mr-sm" />Chargement...
							</div>
							<!-- <div v-if="!$apollo.loading && !loadingMoreInbox && $refs.loadMoreEl">{{ $refs.loadMoreEl.offsetTop }}</div> -->
						</td>
					</tr>
				</tbody>
			</table>
		</div>

	</div>
</template>

<script>
    import { MYPROFILE } from '@/graphql/user/queries'
	import { PROJECTSINBOX } from "@/graphql/notification/queries";
    import { USERASSIGNMENTS } from "@/graphql/assignment/queries";
    import { ACCEPTNOTIFICATIONASSIGNMENT } from "@/graphql/notification/mutations"
	import AcceptationSelect from "@/components/forms/AcceptationSelect"

	export default {
		name: "Assignments",
		components: {
			AcceptationSelect
		},
		props: {
            myUserProfileRole: {
                type: String,
                default(){
                    return window.myUserProfileRole
                }
            },
            myUserProfileID: {
                type: String,
                default(){
                    return window.myUserProfileID
                }
            },
		},
		data(){
			return {
				userProfile: null,
				userProfileID: null,
				tab: 'notifications',
				loading: false,
				loadingMore: false,
				updateQuery: false,
				clickedAssignments:[],
				clickedProjects:[],
				lastDenyReason: null,
				inboxScrollTo: null,
				inboxPage: 1,
				pageSize: 25,
				loadingMoreInbox:false
			}
		},
		methods: {
			parseDate(dateStr){
				let date=new this.$str2date(dateStr)
				return this.$dayStr(date.getDate())+' '+this.$monthStr(date).full.toLowerCase()+' '+date.getFullYear();
			},
			changeInbox(event){
				this.inboxPage=1;
				this.userProfileID=parseInt(event.id);
			},
			log(msg){
				console.log(msg)
			},
			toggleExpandedProject(project){
				document.querySelectorAll('tbody.-expanded:not(#project'+project.id+')').forEach(el =>{el.classList.toggle('-expanded')});
				let dst=document.getElementById('project'+project.id);
				dst.classList.toggle('-expanded');
				if(dst.classList.contains('-expanded')) this.getAssignments(project, 1);
			},
			acceptAssignment(option, project, projectID=null, assignmentID=null){
				if(option.reason) this.lastDenyReason=option.reason;

				if(assignmentID) document.getElementById('assignment'+assignmentID).classList.toggle('-is-hidden');
				if(assignmentID){
					this.clickedAssignments.push(assignmentID)
				}else if(projectID){
					this.clickedProjects.push(projectID)
				}

				this.updateQuery=true;
				this.$apollo.mutate({
                    mutation: ACCEPTNOTIFICATIONASSIGNMENT,
                    variables: {
                        assignmentID: assignmentID,
                        projectID: projectID,
                        userProfileID: this.userProfileID,
                        action: option.value,
                        message: option.reason,
                        page: 1,
                        first: project.userAssignments.data.length
                    }
				}).then(function(data){
					project.userAssignments.data=JSON.parse(JSON.stringify(data.data.acceptAssignment.data));
					project.userAssignments.paginatorInfo.hasMorePages=data.data.acceptAssignment.paginatorInfo.hasMorePages;
					this.updateQuery=false;

					if(project.userAssignments.data.length==0) this.$apollo.queries.projectsInbox.refetch();
				}.bind(this))
			},
			getMoreAssignments(project){
				this.getAssignments(project, project.userAssignments.paginatorInfo.currentPage+1)
			},
			getAssignments(project, page=1, first=5){
				this.updateQuery=true;
                let variables={
                        projectID: project.id,
                        userProfileID: this.userProfileID,
                        page: page,
						first: first,
						pending: true
				}
				if(variables.page>1){
					this.loadingMore=true;
				}else{
					this.loading=true;
				}
				this.$apollo.query({
                    query: USERASSIGNMENTS,
                    fetchPolicy: 'network-only',
					variables: variables
				}).then((data) => {
					let tmp=JSON.parse(JSON.stringify(data.data.userAssignments));
					if(variables.page>1){
						tmp.data=project.userAssignments.data.concat(tmp.data);
					}

					project.userAssignments=JSON.parse(JSON.stringify(tmp));
					this.loading=false;
					this.loadingMore=false;
					this.updateQuery=false;

				})
			},
			groupCustomtags(customtags){
				let tmp=null;
				customtags.forEach(function(tag){
					let index=tag.customtag_label_id
					if(!tmp) tmp={};
					if(!tmp[index]) tmp[index]=[];
					tmp[index].push(tag);
				})
				let customtagsGroups=[];
				if(tmp) customtagsGroups=Object.values(tmp);
				return customtagsGroups;
			},
			groupResources(resources){
				let tmp=null;
				resources.forEach(function(resource){
					let index=resource.type.id
					if(!tmp) tmp={};
					if(!tmp[index]) tmp[index]=[];
					tmp[index].push(resource);
				})
				let resourcesGroups=[];
				if(tmp) resourcesGroups=Object.values(tmp);
				return resourcesGroups;
			},
			onDocumentScroll(){
				if(!this.projectsInbox?.paginatorInfo.hasMorePages) return;

				clearTimeout(this.inboxScrollTo);
				this.inboxScrollTo=setTimeout(function(){
                    var loadMoreEl = this.$refs["loadMoreEl"];
					if(loadMoreEl && loadMoreEl.getBoundingClientRect().top - window.innerHeight < 100){
						this.loadingMoreInbox=true;
						this.getMoreProjectInbox();
					}

				}.bind(this), 300)
			},
			getMoreProjectInbox(){
				this.inboxPage++;
                this.$apollo.queries.projectsInbox.fetchMore({
                    variables: {
                        page: this.inboxPage,
                        first: this.pageSize,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
						this.loadingMoreInbox=false;
						return {
							projectsInbox: {
								__typename: previousResult.projectsInbox.__typename,
								data: [...previousResult.projectsInbox.data, ...fetchMoreResult.projectsInbox.data],
								paginatorInfo: fetchMoreResult.projectsInbox.paginatorInfo
							}
						}
					}
				})
			}
		},
		mounted(){
			this.userProfile=this.myProfile;

			document.onscroll = function(e){
				this.onDocumentScroll(e);
			}.bind(this)

			// var loadMoreEl = this.$refs["loadMoreEl"];

		},
        beforeDestroy() {
			document.onscroll = null;
		},
		watch:{
			projectsInbox: function(){
				this.$nextTick(function(){
					this.inboxPage=this.projectsInbox.paginatorInfo.currentPage;
					this.onDocumentScroll();
				}.bind(this))
			}
		},
        apollo: {
            myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
				},
				update(data){
					this.userProfileID=data.myProfile.id
					return data.myProfile
				}
			},
			projectsInbox: {
				query: PROJECTSINBOX,
				fetchPolicy: 'cache-and-network',
				error(error){
					if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
				},
				variables() {
					return {
						userProfileID: this.userProfileID,
						page: 1,
                        first: this.pageSize,
					}
				},
				update(data) {
					if(!this.updateQuery){
						data.projectsInbox.data.forEach(function(project){
							project.userAssignments=[];
						})
					}
					this.onDocumentScroll()
					return data.projectsInbox
				},
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import "@/scss/views/Dashboard.scss";
</style>
<style lang="scss">
	@import "@/scss/views/Affectations.scss";
</style>
